import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SummaryEffects, summaryReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([SummaryEffects]), StoreModule.forFeature(`summary`, summaryReducer)]
})
export class SummaryStateModule {}
